import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { labelTipoReporteAuditoria } from '../../services/funcionesPublicas'

const ModalAuditoriaMovimientosPersonal = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, empleado } = params

  const [ movimientos, setMovimientos ] = useState<any>([])
  const cargarMovimientos = async()=>{
    try{
      
      let response : any = await RequestService.getEndPoint(`empleado/movimientos/${empleado.uuid}`)
      setMovimientos(response.data)
    }
    catch(e){
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarMovimientos()
  }, []);



    

  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Auditoria de Movimientos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(empleado)
          }
          <small>Empleado</small>
          <h5>{empleado.nombres} {empleado.paterno} {empleado.materno} </h5>



          {
            movimientos.length === 0 && (
                <>
                  <p><i className="fa fa-warning"/> Este usuario no cuenta con movimientos</p>
                </>
              )
          }




          {
            movimientos.length > 0 && (
                <>
          {
            // JSON.stringify(movimientos)
          }

<table className="table">
  <thead>
    <tr>
      <th scope="col">Tipo de Movimiento</th>
      <th scope="col">Detalles</th>
    </tr>
  </thead>
  <tbody>
    {
      movimientos.map((movimiento:any)=>
            <tr key={ Math.random().toString(36).substr(2, 9) }>

              <td className="v text-right" style={{"width":"300px"}}>
                <p className="nm"><b>{labelTipoReporteAuditoria(movimiento.tipo_movimiento)}</b></p>
              </td>
              <td className="v text-right" >
                
                {movimiento.tipo_movimiento!=='CAMBIO_INFORMACION_PERSONAL' && (<p className="nm"><small>{movimiento.detalles}</small></p>) }

                <small><b>{movimiento.fecha_creacion}</b></small>
              </td>
            </tr>
        )
    }

  </tbody>
</table>


                </>
              )
          }
        </Modal.Body>
      </Modal>
    </>
  );
}


export default ModalAuditoriaMovimientosPersonal;